module.exports = __webpack_public_path__ + "img/icon-edit.19603d6b.svg";